import { useState, useEffect, useContext } from "react";
import { AirCoolerContext } from "../context/AirCoolerContext";

function AirCooler({
  tag = "A-101A",
  x = 100,
  y = 100,
  size = 80,
  bladeCount = 3,
  bladeLength = 22,
  rpm = 0,
  baseRPM = 1900,
  onClick,
  style = {}
}) {


  /* =======================
     1. STATE
  ======================= */

  const [angle, setAngle] = useState(0);

  const [hover, setHover] = useState(false);



  /* =======================
     2. CONTEXT
  ======================= */

  const ctx = useContext(AirCoolerContext);



  const running =
    ctx?.coolerData?.[tag]?.running ?? false;



  /* =======================
     3. SPEED
  ======================= */

  const speedFactor =
    running ? rpm / baseRPM : 0;



  /* =======================
     4. ROTATION
  ======================= */

  useEffect(() => {


    if (!running) return;


    const interval =
      setInterval(() => {


        setAngle(prev =>
          prev + (2 + speedFactor * 8)
        );


      },50);



    return () =>
      clearInterval(interval);



  },[running,speedFactor]);




  /* =======================
     5. BLADES
  ======================= */


  const blades=[];


  for(let i=0;i<bladeCount;i++){


    const rotation =
      (360 / bladeCount) * i;


    blades.push(

      <rect

        key={i}

        x={-3}

        y={-bladeLength}

        width={6}

        height={bladeLength}

        rx={2}

        fill="white"

        transform={
          `rotate(${rotation})`
        }

      />

    );


  }





  return (

    <div

      style={{
        position:"absolute",

        left:x,

        top:y,

        width:size,

        cursor:"pointer",

        ...style
      }}


      onClick={() =>
        onClick && onClick(tag)
      }


      onMouseEnter={() =>
        setHover(true)
      }


      onMouseLeave={() =>
        setHover(false)
      }


    >



      {/* ==================================
          HOVER TAG DISPLAY
      ================================== */}


      {hover && (

        <div

          style={{

            position:"absolute",

            top:-32,

            left:"50%",


            transform:
            "translateX(-50%)",


            background:"#000",

            color:"#00ffcc",


            fontSize:"13px",


            fontWeight:"bold",


            padding:"4px 10px",


            borderRadius:"4px",


            border:"1px solid #555",


            whiteSpace:"nowrap",


            zIndex:9999,


            pointerEvents:"none"

          }}

        >

          {tag}

        </div>

      )}







      {/* ==================================
          AIR COOLER SVG
      ================================== */}



      <svg

        width={size}

        height={size}

        viewBox="-50 -50 100 100"

      >



        <circle

          cx="0"

          cy="0"

          r="40"

          fill={
            running ? "lime" : "red"
          }

          stroke="black"

          strokeWidth="3"

        />



        <g

          transform={
            `rotate(${angle})`
          }

        >

          {blades}

        </g>




        <circle

          cx="0"

          cy="0"

          r="6"

          fill="black"

        />


      </svg>






    </div>


  );

}


export default AirCooler;